import { css } from '@emotion/css';
import { Spinner, Text } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

const backgroundStyle = css`
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
`;

const container = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const spinnerContainer = css`
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translate(-50%, 50%);
  margin: 0 auto;
`;

function ImageLoadView(): JSX.Element {
  const { t } = useTranslation();

  const title = 'algoValidation.loadingYourImage';

  return (
    <div className={backgroundStyle}>
      <div
        style={{
          paddingTop: '16px',
          textAlign: 'center',
        }}
      >
        <Text style={{ color: 'white', fontSize: '16px' }}>{t(title)}</Text>
      </div>
      <div className={container}>
        <div className={spinnerContainer}>
          <Spinner size="52px" />
        </div>
      </div>
    </div>
  );
}

export default ImageLoadView;
